/* HYPE SIDE — estados do botão "Adicionar ao carrinho" do card de catálogo
   (snippets/hs-catalog-card.liquid).

   O pedido ao carrinho é feito pelo fluxo nativo do tema:
     - product-form.js (produto sem tamanhos): spinner + aria-disabled durante o pedido
     - quick-add.js (produto com tamanhos): abre a janela com o formulário da
       página de produto
   Aqui só se acrescenta:
     - bloqueio de cliques repetidos enquanto o pedido/janela está a carregar
     - "Adicionado" no próprio card quando o produto entra no carrinho
     - estado de erro no card quando a adição direta falha */
(function () {
  if (window.hsCatalogCardReady) return;
  window.hsCatalogCardReady = true;

  var pending = null; // { card, button, direct }
  var WINDOW_MS = 120000;

  function setState(button, state, ms) {
    if (!button) return;
    clearTimeout(button._hsTimer);
    button.setAttribute('data-state', state);
    button._hsTimer = setTimeout(function () {
      button.removeAttribute('data-state');
    }, ms);
  }

  // Captura: corre antes do modal-opener e do submit do formulário
  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest && event.target.closest('.hs-ccard__add');
      if (!button) return;
      if (button.disabled || button.getAttribute('aria-disabled') === 'true' || button.classList.contains('loading')) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      button.removeAttribute('data-state');
      pending = {
        button: button,
        direct: button.type === 'submit',
        time: Date.now(),
      };
    },
    true
  );

  // A janela de tamanhos fechou sem adicionar → esquecer o card
  document.body.addEventListener('modalClosed', function () {
    setTimeout(function () {
      if (pending && !pending.direct) pending = null;
    }, 0);
  });

  function fresh() {
    return pending && Date.now() - pending.time < WINDOW_MS;
  }

  function init() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!fresh() || !event || event.source !== 'product-form') return;
      setState(pending.button, 'added', 2400);
      pending = null;
    });

    subscribe(PUB_SUB_EVENTS.cartError, function () {
      if (!fresh() || !pending.direct) return; // na janela, o erro aparece no próprio formulário
      setState(pending.button, 'error', 3500);
      pending = null;
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
